import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  iconButton: {
    margin: `${theme.spacing(-1)} 0 !important`,
  },
  input: {
    marginTop: `${theme.spacing(-0)} !important`,
    width: '200px !important',
    maxWidth: '100% !important',
    fontSize: 'inherit !important',
    fontWeight: 'inherit !important',
    '& *': {
      fontSize: 'inherit !important',
      fontWeight: 'inherit !important',
    },
  },
}))
